import React from 'react'
import SVGInline from '@/v2/components/common/SVGInline'
import Typography from '@/v2/components/common/Typography'
import { formatPhone } from '@/v2/utils/format'
import Button from '@/v2/components/common/Button'
import {
  PatientProfileHeader,
  PatientProfileSection,
  PatientProfile,
  PatientWrapper,
  PatientActions,
  Appointments,
  AppointmentsContainer,
} from './styles'
import AppointmentsList from '@/v2/containers/patient-profile/Appointments/AppointmentsList'
import PatientAvatar from '@/v2/components/common/PatientAvatar'
import PersonIcon from '#/assets/images/icons/v2/profile.svg?raw'
import MessageIcon from '#/assets/images/icons/v2/write-messages.svg?raw'
import Labels from './Labels'
import { Skeleton } from '@mui/material'

const Patient = ({ patient, appointment }) => {
  if (!patient) return <Skeleton variant="rectangular" height={300} />

  return (
    <PatientWrapper>
      <PatientProfileSection>
        <PatientProfileHeader>
          <PatientAvatar patient={patient} />
          <PatientProfile>
            <Typography fontSize="16px" marginBottom="8px" variant="h3">
              {patient.fullName}
            </Typography>
            <Typography variant="h5" fontSize="14px">
              {patient.email}
            </Typography>
            <Typography variant="h5" fontSize="14px">
              {formatPhone(patient.phoneNumber)}
            </Typography>
          </PatientProfile>
        </PatientProfileHeader>

        <PatientActions>
          <Button
            variant="profile"
            startIcon={
              <SVGInline
                className="message-icon"
                svg={PersonIcon}
                height="12px"
                width="12px"
              />
            }
            href={`/v2/patient/${patient.id}/profile`}
          >
            See Profile
          </Button>

          <Button
            variant="profile"
            startIcon={
              <SVGInline svg={MessageIcon} height="12px" width="12px" />
            }
            href={`/v2/messages/start-conversation/${patient.id}`}
            onClick={e => {
              if (patient.phoneNumber === null) {
                e.preventDefault()
                e.stopPropagation()
                alert(
                  "This patient doesn't have a phone number!\nPlease, update the patient contact info."
                )
              }
            }}
          >
            Send Message
          </Button>
        </PatientActions>
      </PatientProfileSection>

      <Labels appointment={appointment} />
      <AppointmentsContainer>
        <Appointments>
          {patient?.nextAppointments?.length > 0 && (
            <AppointmentsList
              defaultExpanded
              title="Next Appointments"
              appointments={patient.nextAppointments}
            />
          )}
        </Appointments>
        <Appointments>
          {patient?.previousAppointments?.length > 0 && (
            <AppointmentsList
              defaultExpanded
              title="Previous Appointments"
              appointments={patient.previousAppointments}
            />
          )}
        </Appointments>
        <Button
          href={`/v2/patient/${patient?.id}/treatment`}
          fullWidth
          variant="outlined"
          sx={{
            marginLeft: '-1px',
          }}
        >
          View all appointments
        </Button>
      </AppointmentsContainer>
    </PatientWrapper>
  )
}

export default Patient
